// auth
export const LOGIN = "login";
export const SIGNUP = "signup";
export const GOOGLE_AUTH = "googleAuth";
export const LOGOUT = "logout";
export const UPDATE_ACCOUNT = "updateAccount";
export const GET_AUTH_ACCOUNT = "getAuthAccount";
export const CLEAR_ACCOUNT_ISLOADING = "clearAccountIsLoading";

// users (team management — backend exposes list / add / remove)
export const GET_USERS = "getUsers";
export const REGISTER_USER = "registerUser";
export const DELETE_USER = "deleteUser";
export const CLEAR_USERS_ISLOADING = "clearUsersIsLoading";

// verifications
export const GET_VERIFICATIONS = "getVerifications";
export const VERIFY_TRANSACTION = "verifyTransaction";
export const UPDATE_VERIFICATION_STATUS = "updateVerificationStatus";
export const TOGGLE_VERIFICATION_IS_ACTIVE = "toggleVerificationIsActive";
export const DELETE_VERIFICATION = "deleteVerification";
export const CLEAR_VERIFICATIONS_ISLOADING = "clearVerificationsIsLoading";

// bank (recipient) accounts
export const GET_BANK_ACCOUNTS = "getBankAccounts";
export const REGISTER_BANK_ACCOUNT = "registerBankAccount";
export const EDIT_BANK_ACCOUNT = "editBankAccount";
export const TOGGLE_BANK_ACCOUNT_IS_ACTIVE = "toggleBankAccountIsActive";
export const DELETE_BANK_ACCOUNT = "deleteBankAccount";
export const CLEAR_BANK_ACCOUNTS_ISLOADING = "clearBankAccountsIsLoading";

// subscription + plans
export const GET_SUBSCRIPTIONS = "getSubscriptions";
export const GET_SUBSCRIPTION_PLANS = "getSubscriptionPlans";
export const INITIALIZE_SUBSCRIPTION = "initializeSubscription";
export const VERIFY_SUBSCRIPTION_PAYMENT = "verifySubscriptionPayment";
export const CLEAR_SUBSCRIPTIONS_ISLOADING = "clearSubscriptionsIsLoading";

// router_loader
export const UPDATE_ROUTER_LOADER = "updateRouterLoader";

// error
export const CLEAR_ERRORMSG = "clearErrorMessage";
export const UPDATE_ERRORMSG = "updateErrorMessage";
